import { AnyResource } from '@models';

import { AiConversation, AiMode } from './ai-assistant.types';

export type AiPanelState = 'expanded' | 'minimized';

export interface AiPanel {
  id: string;
  resource: AnyResource;
  mode: AiMode;
  title: string;
  state: AiPanelState;
  seq: number;
  conversation: AiConversation;
}

export interface DockLayout {
  expanded: AiPanel[];
  bars: AiPanel[];
  overflow: AiPanel[];
}

export const PANEL_WIDTH_PX = 640;
export const MINIMIZED_WIDTH_PX = 256;
export const OVERFLOW_WIDTH_PX = 72;
export const LG_PX = 992;

export const AI_MODE_KEY: Record<AiMode, string> = {
  chat: 'WEB_AI_CHAT',
  summarize: 'WEB_AI_SUMMARY',
  translate: 'WEB_AI_TRANSLATION',
};

export const AI_MODAL_CLOSED = '__ai_modal_closed__';

export const expandedCapFor = (width: number): number =>
  width < LG_PX ? 1 : Math.max(1, Math.floor(width / PANEL_WIDTH_PX));

export const computeDockLayout = (
  panels: AiPanel[],
  width: number
): DockLayout => {
  const byRecency = [...panels].sort((a, b) => b.seq - a.seq);
  const expanded = byRecency.filter((panel) => panel.state === 'expanded');
  const minimized = byRecency.filter((panel) => panel.state === 'minimized');

  const available = Math.max(0, width - expanded.length * PANEL_WIDTH_PX);
  const fitAll = Math.floor(available / MINIMIZED_WIDTH_PX);

  if (minimized.length <= fitAll) {
    return { expanded, bars: minimized, overflow: [] };
  }

  const fitWithOverflow = Math.max(
    0,
    Math.floor((available - OVERFLOW_WIDTH_PX) / MINIMIZED_WIDTH_PX)
  );

  return {
    expanded,
    bars: minimized.slice(0, fitWithOverflow),
    overflow: minimized.slice(fitWithOverflow),
  };
};
